var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgSmsEngageV2 = function SvgSmsEngageV2(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4999 9.40625C17.4999 13.1887 14.1265 16.2246 9.99988 16.2246C9.46572 16.2246 8.94572 16.1721 8.44238 16.0754",
    stroke: "var(--Icon-Primary)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49917 14.8521C3.68333 13.6104 2.5 11.6421 2.5 9.40625",
    stroke: "var(--Icon-Primary)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49937 14.8594C5.49854 15.571 5.50021 16.531 5.50021 17.5385",
    stroke: "var(--Icon-Primary)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 9.41125C2.5 5.62875 5.87333 2.59375 10 2.59375C14.1267 2.59375 17.5 5.62958 17.5 9.41208",
    stroke: "var(--Icon-Primary)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44167 16.0781L5.5 17.5365",
    stroke: "var(--Icon-Primary)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.147 9.44123C10.2283 9.52259 10.2283 9.6545 10.147 9.73586C10.0656 9.81721 9.93372 9.81721 9.85236 9.73586C9.771 9.6545 9.771 9.52259 9.85236 9.44123C9.93372 9.35987 10.0656 9.35987 10.147 9.44123",
    stroke: "var(--Icon-Primary)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.481 9.44123C13.5623 9.52259 13.5623 9.6545 13.481 9.73586C13.3996 9.81721 13.2677 9.81721 13.1863 9.73586C13.105 9.6545 13.105 9.52259 13.1863 9.44123C13.2677 9.35987 13.3996 9.35987 13.481 9.44123",
    stroke: "var(--Icon-Primary)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.81398 9.44123C6.89534 9.52259 6.89534 9.6545 6.81398 9.73586C6.73262 9.81721 6.60071 9.81721 6.51935 9.73586C6.43799 9.6545 6.43799 9.52259 6.51935 9.44123C6.60071 9.35987 6.73262 9.35987 6.81398 9.44123",
    stroke: "var(--Icon-Primary)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgSmsEngageV2;